import { ref, type Ref } from 'vue'
import type { HblIUseDrawer } from '@/utils/types'

const drawerState: Ref<boolean> = ref(false)
const drawerContext: Ref<string> = ref('')
const drawerDirection: Ref<'left' | 'right'> = ref('right')
const drawerInnerRef: Ref<HTMLElement | null> = ref(null)

// The drawer becomes visible through a delayed visibility transition, and focus() is ignored while it is hidden.
function focusDrawerWhenVisible (deadline: number) {
    const drawer = drawerInnerRef.value
    if (drawer == null || !drawerState.value) {
        return
    }

    if (getComputedStyle(drawer).visibility === 'visible') {
        drawer.focus()
        return
    }

    if (performance.now() < deadline) {
        requestAnimationFrame(() => focusDrawerWhenVisible(deadline))
    }
}

export function useDrawer (): HblIUseDrawer {
    const toggleDrawer = function (context: string, direction: 'left' | 'right') {
        if (direction) {
            drawerDirection.value = direction
        }

        drawerContext.value = drawerContext.value === '' ? context : ''
        drawerState.value = !drawerState.value

        if (drawerState.value) {
            nextTick(() => focusDrawerWhenVisible(performance.now() + 1000))
        }
    }


    const closeDrawer = function () {
        drawerState.value = false
        drawerContext.value = ''
    }

    return {
        drawerState,
        drawerContext,
        drawerDirection,
        toggleDrawer,
        closeDrawer,
        drawerInnerRef
    }
}
